import React, { useState } from 'react'

import { Form } from '../../../../components/Form/Form'
import Select from '../../../../components/Select/Select'
import SelectItem from '../../../../components/Select/SelectItem'
import t from '../../../../helpers/i18n'

const NewCompetitionStepSeven = ({ usingGroups, data, setFormValid }) => {
  const [, setConfiguration] = useState()

  return (
    <div>
      <h3>{t('titles.New competition - Match Fixtures')}</h3>
      <Form data={data} onValidityChange={setFormValid}>
        <Select
          onChange={(value) => setConfiguration(value)}
          label={t('labels.Configuration')}
          required
        >
          <SelectItem>- {t('select_item.Select_a_configuration')} -</SelectItem>
          <SelectItem value='manual'>{t('select_item.Manual')}</SelectItem>
          <SelectItem value='automatic'>{t('select_item.Automatic')}</SelectItem>
        </Select>
      </Form>
    </div>
  )
}

export default NewCompetitionStepSeven
